import {Component, Inject, OnInit} from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ImageService} from '../../../common/services';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {
  file: string;
  imageId: number;
  height: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImagePreviewComponent>,
    private imageService: ImageService) {
    if (data) {
      this.height = 650;
      this.file = data.file;
      this.imageId = data.id;
    }
  }

  close() {
    this.dialogRef.close();
  }

  download() {
    this.imageService.download(this.imageId, this.file);
  }

  ngOnInit() {
  }

}
